import React from 'react';
import { Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { useNavigate } from 'react-router-dom';
import { NotFoundContainer } from './NotFound.styles';

export const NotFound: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <NotFoundContainer>
            <SentimentVeryDissatisfiedIcon sx={{ fontSize: 80, color: theme.palette.primary.main }} />
            <Typography variant="h4" color="error" sx={{ fontWeight: 700 }}>
                404 - Page Not Found
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ textAlign: 'center', maxWidth: 400 }}>
                Sorry, the page you are looking for does not exist.<br />
                Please check the URL or return to the homepage.
            </Typography>
            <Button variant="contained" color="primary" onClick={() => navigate('/')}
                sx={{ mt: 2, textTransform: 'none', fontWeight: 600 }}>
                Go to Home
            </Button>
        </NotFoundContainer>
    );
}
